import { useBooleanValue } from '@edikk-edikk/hooks';
import { useAdvertCardContext } from '#advert/components/card';

const useFavoriteToggleControls = () => {
  const { clickLogicForFavoriteToggle, advert } = useAdvertCardContext();
  const {
    advert: {
      isFavorite,
    },
  } = useAdvertCardContext();
  const [isProcess, setIsProcessAsTrue, setIsProcessAsFalse] = useBooleanValue();

  const handlerClick = async () => {
    setIsProcessAsTrue();

    await clickLogicForFavoriteToggle(advert.id, isFavorite);

    setIsProcessAsFalse();
  };

  return {
    isProcess,
    handlerClick,
  };
};

export { useFavoriteToggleControls };
